import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// ReactiveForms
import { ReactiveFormsModule } from '@angular/forms';
import {HttpClientModule} from "@angular/common/http";
import {provideAuth} from "./services/auth/auth.provider";

@NgModule({
    declarations: [AppComponent],
    imports: [
      BrowserModule,
      IonicModule.forRoot({ mode: 'ios' }),
      ReactiveFormsModule,
      AppRoutingModule,
      HttpClientModule
    ],
    providers: [
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      provideAuth(),
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
